import { capabilitiesQuery } from './capabilities';

export const SYSTEM_CAPABILITIES_ID = 'arcticwolf';

export const systemCapabilitiesQuery = () =>
  capabilitiesQuery(SYSTEM_CAPABILITIES_ID);
